import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Input,
  Loader,
  LoadingOverlay,
  Menu,
  MultiSelect,
  rem,
  Select,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import {
  IconBrandBootstrap,
  IconCaretDown,
  IconFileExport,
  IconFileTypography,
  IconSearch,
  IconTimeDuration15,
  IconX,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  repositoryMdm,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../../_base/component/_layout/_breadcrumb";
import { SelectListItemBase } from "../../../../_base/model/_base/SelectListItemBase";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../../common/FormatDate/FormatDate";
import { BASE_API_MDM } from "../../../../config";
import { _localization } from "../../../../config/location";
import { green } from "../../../../const/variables";
import { MessageResponse } from "../../../../model/MessageResponse";
import { useDisclosure } from "@mantine/hooks";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";

interface ProductionOrder {
  ma_Cn: string;
  ten_Cn: string;
  ma_Lenh_SX: string;

  ma_Tp: string;
  ten_Tp: string;
  so_Px_Asia: string;
  serial: string;
  so_Px_Dc_Lk: string;
  ngay_Xuat_Dc_Lk: string;
  so_Pn_Dc_Lk: string;
  ngay_Nhap_Dc_Lk: string;
  ma_Px_lk: string | null;

  nv_Xuat_Lk: string;
  ngay_Xuat_Lk: string;
  phieu_Kt: string;
  muc_Do_Test: string | null;
  diem_Test: number;
  so_Pn_Tp: string;
  nv_Nhap_Tp: string;
  ngay_Nhap_Tp: string;
  tt_Pxlk: string;
  tt_Lsx: string;
  ngay_Ct_Lsx: string;
}

const TrangThaiLenhSanXuat = {
  DIEU_CHUYEN_HOAN_THANH: "Điều chuyển hoàn thành",
  DANG_LAP_RAP: "Đang lắp ráp",
  XUAT_DIEU_CHUYEN: "Xuất điều chuyển",
  DANG_XUAT_LINH_KIEN: "Đang xuất linh kiện",
  HOAN_THANH: "Hoàn thành",
  DA_XUAT_LINH_KIEN: "Đã xuất linh kiện",
  TAO_MOI: "Tạo mới",
  NHAP_DIEU_CHUYEN: "Nhập điều chuyển",
  DONG: "Đã đóng lệnh",
  HOAN_THANH_MOT_PHAN: "Hoàn thành một phần",
};

const TrangThaiLenhSanXuatSelect = [
  { value: "DIEU_CHUYEN_HOAN_THANH", label: "Điều chuyển hoàn thành" },
  { value: "DANG_LAP_RAP", label: "Đang lắp ráp" },
  { value: "XUAT_DIEU_CHUYEN", label: "Xuất điều chuyển" },
  { value: "DANG_XUAT_LINH_KIEN", label: "Đang xuất linh kiện" },
  { value: "HOAN_THANH", label: "Hoàn thành" },
  { value: "HOAN_THANH_MOT_PHAN", label: "Hoàn thành một phần" },
  { value: "DA_XUAT_LINH_KIEN", label: "Đã xuất linh kiện" },
  { value: "TAO_MOI", label: "Tạo mới" },
  { value: "NHAP_DIEU_CHUYEN", label: "Nhập điều chuyển" },
  { value: "DONG", label: "Đã đóng lệnh" },
];

const MfgWipReport = () => {
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [data, setData] = useState<ProductionOrder[]>([]);
  const [dataBranch, setDataBranch] = useState<SelectListItemBase[]>([]);

  const [rowCount, setRowCount] = useState(0);
  const [search, setSearch] = useState({
    keySearch: "",
    branchCode: [],
    itemCode: [],
    ttPxlk: "",
    fromDate: "",
    toDate: "",
    ttLsx: [],
  });
  const TrangThaiPhieuXuatLinhKien = [
    { value: "LOCK", label: "Hoàn thành" },
    { value: "CANCLE", label: "Huỷ bộ" },
  ];
  const handleChangeSearchValue = (value: string[] | null, key: string) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : [],
    }));
  };

  const handleChangeSearch = (value: string | null, key: string) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : 0,
    }));
  };
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch"
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };

  const detailData = (transactionCode: string) => {
    navigate("/warehouse-config/detail-warehouse-out-ward", {
      state: {
        transactionCode: transactionCode,
        type: "XUAT_LINH_KIEN_SAN_XUAT",
        isLocked: true,
      },
    });
  };

  const sizeGrid = { base: 6, sm: 6, md: 4, lg: 4, xl: 2 };

  const columns = React.useMemo<MRT_ColumnDef<ProductionOrder>[]>(
    () => [
      {
        accessorKey: "ma_Lenh_SX",
        header: "Mã lệnh sản xuất",
        size: 160,
        Cell: ({ renderedCellValue, cell, row }) => {
          //    settypeKey(row.original.type);
          return (
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue}
            </Badge>
          );
        },
      },
      {
        accessorKey: "ngay_Ct_Lsx",
        header: "Ngày CT lệnh sản xuất",
        size: 230,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "tt_Lsx",
        header: "Trạng thái LSX",
        size: 200,
        Cell: (props) => {
          const { renderedCellValue } = props;

          // Ép kiểu cẩn thận và an toàn
          const key = renderedCellValue as keyof typeof TrangThaiLenhSanXuat;

          return <>{TrangThaiLenhSanXuat[key] || renderedCellValue}</>;
        },
      },
      {
        accessorKey: "ma_Tp",
        header: "Mã thành phẩm",
        size: 160,
      },
      // {
      //   accessorKey: "codePhieuXuatDc",
      //   header: "Phiếu điều chuyển thành phẩm",
      // },
      {
        accessorKey: "ma_Cn",
        header: "Chi nhánh",

        Cell: ({ renderedCellValue, cell }) => (
          <>{renderedCellValue + " - " + cell.row.original.ten_Cn}</>
        ),
      },
      {
        accessorKey: "ten_Tp",
        header: "Tên thành phẩm",
        size: 500,
      },
      {
        accessorKey: "so_Px_Asia",
        header: "Số phiếu xuất Asia",
        Cell: ({ renderedCellValue, cell, row }) => {
          //    settypeKey(row.original.type);
          return (
            <Box pl={10}>
              <Badge
                radius="lg"
                variant="light"
                bd="1px solid blue"
                size="md"
                color={"blue"}
              >
                {renderedCellValue}
              </Badge>
            </Box>
          );
        },
      },
      {
        accessorKey: "serial",
        header: "Serial",
      },
      {
        accessorKey: "so_Px_Dc_Lk",
        header: "Số phiếu xuất điều chuyển",
        size: 240,
        Cell: ({ renderedCellValue, cell, row }) => {
          //    settypeKey(row.original.type);
          return (
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : "blue"}
            >
              {renderedCellValue}
            </Badge>
          );
        },
      },
      {
        accessorKey: "ngay_Xuat_Dc_Lk",
        header: "Ngày xuất điều chuyển ",
        size: 230,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "so_Pn_Dc_Lk",
        header: "Số phiếu nhập điều chuyển",
        size: 250,
        Cell: ({ renderedCellValue, cell, row }) => {
          //    settypeKey(row.original.type);
          return (
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : "orange"}
            >
              {renderedCellValue}
            </Badge>
          );
        },
      },
      {
        accessorKey: "ngay_Nhap_Dc_Lk",
        header: "Ngày nhập điều chuyển",
        size: 230,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "ma_Pxlk",
        header: "Mã phiếu xuất linh kiện",
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : "aqua"}
              onDoubleClick={() =>
                detailData(renderedCellValue?.toString() ?? "")
              }
            >
              {renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "tt_Pxlk",
        header: "Trạng thái PXLK",
        size: 200,
        Cell: ({ renderedCellValue }: any) => (
          <>
            {renderedCellValue === "LOCK"
              ? "Hoàn thành"
              : renderedCellValue === "CANCLE"
              ? "Huỷ"
              : ""}
          </>
        ),
      },
      {
        accessorKey: "nv_Xuat_Lk",
        header: "Nhân viên xuất linh kiện",
        size: 230,
      },
      {
        accessorKey: "ngay_Xuat_Lk",
        header: "Ngày xuất linh kiện",
        size: 230,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "phieu_Kt",
        header: "Phiếu kiểm tra",
      },
      {
        accessorKey: "muc_Do_Test",
        header: "Mức độ kiểm tra",
      },
      {
        accessorKey: "diem_Test",
        header: "Điểm kiểm tra",
      },
      {
        accessorKey: "so_Pn_Tp",
        header: "Số phiếu nhập TP",
      },
      {
        accessorKey: "nv_Nhap_Tp",
        header: "Nhân viên nhập TP",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? renderedCellValue : null}</>
        ),
      },
      {
        accessorKey: "ngay_Nhap_Tp",
        header: "Ngày nhập thành phẩm",
        size: 230,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableRowNumbers: true,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,
    rowCount,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-numbers"],
        // right: ["statusName"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
        display: "none",
      },
    },
    localization: _localization,
    // getRowId: (row) => row.,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  //lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.branchCode && search.branchCode.length > 0) {
      search.branchCode.forEach((branchCode) => {
        url += `&BranchCode=${branchCode}`;
      });
    }
    if (search.ttPxlk && search.ttPxlk.length > 0) {
      url += `&ttPxlk=${search.ttPxlk}`;
    }
    if (search.fromDate && search.fromDate.length > 0) {
      url += `&fromDate=${search.fromDate}`;
    }
    if (search.toDate && search.toDate.length > 0) {
      url += `&toDate=${search.toDate}`;
    }
    if (search.ttLsx && search.ttLsx.length > 0) {
      // url += `&ttLsx=${search.ttLsx}`;
      url += search.ttLsx?.map((item) => `&ttLsx=${item}`)?.join("");
    }
    // if (search.itemCode && search.itemCode.length > 0) {
    //   search.itemCode.forEach((itemCode) => {
    //     url += `&MaThanhPhams=${itemCode}`;
    //   });
    // }
    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
    }
    try {
      const response = await repositoryMdm.get(
        `/api/v1/MfgProductionOrder/report${url}`
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  //export excel

  const exportDataExcel = async () => {
    open();
    try {
      let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
        pagination.pageSize
      }`;

      if (search.branchCode && search.branchCode.length > 0) {
        search.branchCode.forEach((branchCode) => {
          url += `&BranchCode=${branchCode}`;
        });
      }
      if (search.ttPxlk && search.ttPxlk.length > 0) {
        url += `&ttPxlk=${search.ttPxlk}`;
      }
      if (search.fromDate && search.fromDate.length > 0) {
        url += `&fromDate=${search.fromDate}`;
      }
      if (search.toDate && search.toDate.length > 0) {
        url += `&toDate=${search.toDate}`;
      }
      if (search.ttLsx && search.ttLsx.length > 0) {
        // url += `&ttLsx=${search.ttLsx}`;
        url += search.ttLsx?.map((item) => `&ttLsx=${item}`)?.join("");
      }
      // if (search.itemCode && search.itemCode.length > 0) {
      //   search.itemCode.forEach((itemCode) => {
      //     url += `&MaThanhPhams=${itemCode}`;
      //   });
      // }
      if (search.keySearch) {
        url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
      }
      const baseUrl = `/api/v1/ExportExcel/export-mfg-report${url}`;

      const _url = BASE_API_MDM + baseUrl;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        let filename = "bao_cao_lap_rap_may.xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        NotificationExtension.Success("Export Excel thành công !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };
  useEffect(() => {
    fetchData();
  }, [pagination]);
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  return (
    <Box>
      <div
        ref={headerRef}
        style={{
          border: "1px solid #dee2e6",
          padding: "10px 10px",
          overflowX: "hidden",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Group justify="space-between">
          <BreadcrumbLayout1></BreadcrumbLayout1>
          <Menu shadow="md" width={200}>
            <Menu.Target>
              <Button
                // size="xs"
                rightSection={
                  <IconCaretDown style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Chức năng
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Label>Application</Menu.Label>
              <Menu.Item
                leftSection={
                  <IconFileExport style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={() => exportDataExcel()}
              >
                Export Excel
              </Menu.Item>
              <Menu.Item
                leftSection={
                  <IconX style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Đóng
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>
        <Grid mt={10}>
          <Grid.Col span={sizeGrid}>
            <Input
              placeholder="Nhập tìm kiếm"
              type="text"
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              onChange={(e) => {
                handleChangeSearch(e.target.value ?? "", "keySearch");
              }}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              flex={1}
              searchable
              clearable
              placeholder="Chi nhánh"
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              data={[...dataBranch]
                .sort((a, b) => (a.att2 > b.att2 ? 1 : -1))
                .map((item) => ({
                  label: `[${item.att2}] - ${item.text}`,
                  value: String(item.att2 ?? ""),
                }))}
              onClick={async () => {
                if (!dataBranch || dataBranch.length < 1) {
                  await fetchDataBranch();
                }
              }}
              onChange={(value) => {
                handleChangeSearchValue([value ?? ""], "branchCode");
              }}
              nothingFoundMessage="Dữ liệu không có!"
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              searchable
              clearable
              leftSection={<IconFileTypography color="#15aabf" />}
              size="sm"
              placeholder="Trạng thái lệnh sản xuất"
              data={TrangThaiLenhSanXuatSelect}
              onChange={(e) => {
                handleChangeSearchValue(e ? e : [], "ttLsx");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              searchable
              clearable
              leftSection={<IconFileTypography color="#15aabf" />}
              size="sm"
              placeholder="Trạng thái phiếu xuất linh kiện"
              data={TrangThaiPhieuXuatLinhKien}
              onChange={(e) => {
                console.log("e", e);
                handleChangeSearch(e ?? "", "ttPxlk");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              type="default"
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              onChange={(e) => {
                handleChangeSearch(formatDateNotTimeZone(e) ?? "", "fromDate");
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              type="default"
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              onChange={(e) => {
                handleChangeSearch(formatDateNotTimeZone(e) ?? "", "toDate");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default MfgWipReport;
